import React, { useContext, useEffect, useState } from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {
  Container,
  Avatar,
  Grid,
  makeStyles,
  Typography,
  CircularProgress,
  useTheme
} from '@material-ui/core'
import moment from 'moment'
import { profileStyle } from '../styles/styles'

const useStyles = makeStyles((theme) => ({
  profile: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    height: '62px',
    width: '62px',
    border: '3px solid #CCCCCC',
    marginRight: '10px',
    background: '#9CA2A5',
    fontSize: '27px'
  },
  profileSection: {
    marginTop: '20px',
    '& div': {
      margin: '0px 0px'
    }
  },
  smallProfileScreen: {
    marginLeft: '34px',
    marginRight: '34px',
    width: '80%'
  }
}))

export const Profile = (props) => {
  const classes = profileStyle()
  const containerClasses = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const ProfileInformation = () => {
    return (
      <Grid container direction='row' justify='flex-start' alignItems='center'>
        <div className={containerClasses.profile}>
          <Avatar className={containerClasses.avatar} xs={1}> {props.profile?.firstName.slice(0, 1)}{props.profile?.lastName.slice(0, 1)}</Avatar>
          <div>
            <Typography variant='caption'>
              <Typography variant='h6'>
                <div>
                  {`${props.profile?.firstName ?? ''} ${props.profile?.lastName ?? ''}`}
                </div>
              </Typography>
              <Typography variant='subtitle1'>
                TravelerID: {props.tid ?? ''}
              </Typography>
            </Typography>
          </div>
        </div>
      </Grid>
    )
  }

  const Qualifications = () => {
    return (
      <Grid container direction='row' justify='flex-start' alignItems='center'>
        <div className={containerClasses.profileSection}>
          <Typography variant='caption'>
            <Typography variant='h6'>
              <div>Qualifications</div>
            </Typography>
            <div>
              Disciplines: {props.profile?.skillsets[0].discipline ?? ''}
            </div>
            <div>
              Specialties: {`${props.profile?.skillsets[0].specialty ?? ''}`}
            </div>
          </Typography>
        </div>
      </Grid>
    )
  }

  const Assignment = () => {
    moment.locale('en')
    const fromDate =
      props.workHistory?.workHistory?.fromDate ?? '2000-01-01T00:00:00'
    const fromDateString = moment(fromDate).format('MM/DD/yyyy')
    const toDate =
      props.workHistory?.workHistory?.toDate ?? '2000-01-01T00:00:00'
    const toDateString = moment(toDate).format('MM/DD/yyyy')

    return (
      <Grid container direction='row' justify='flex-start' alignItems='center'>
        <div className={containerClasses.profileSection}>
          <Typography variant='caption'>
            <Typography variant='h6'>
              <div>Assignment</div>
            </Typography>
            <div>
              <Typography variant='subtitle1'>
                {props.workHistory?.workHistory?.facility}
              </Typography>
            </div>
            <div>
              <Typography variant='subtitle1'>
                {props.workHistory?.workHistory?.city},{' '}
                {props.workHistory?.workHistory?.state}
              </Typography>
            </div>
            <div>
              <Typography variant='subtitle1'>
                {fromDateString} - {toDateString}
              </Typography>
            </div>
          </Typography>
        </div>
      </Grid>
    )
  }

  return (
    <Container className={matches ? containerClasses.smallProfileScreen : ''}>
      <div className={classes.root}>
        {props.profile === null ? (
          <CircularProgress />
        ) : (
          <div>
            <ProfileInformation />
            {/* <Qualifications /> */}
          </div>
        )}
        <Assignment />
      </div>
    </Container>
  )
}
